import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import { baseUrl } from '../components/constant';
import { toast } from 'react-toastify';
import Modal from "react-modal";
import Select from 'react-select';
const Categories = () => {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [BrandList, setBrandList] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [NewSelectedOptions, setNewSelectedOptions] = useState([]);
  
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const navigate = useNavigate();
  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const fetchBrands = async () => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      const response = await fetch(`${baseUrl}/categories/brands`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log("data",data)
        setBrandList(data.brands); // Adjust based on your API response structure
      } else {
        toast.error('Failed to fetch brand');
      }
    } catch (err) {
      setError('Failed to fetch brand');
    } finally {
      setLoading(false);
    }
  };
  const EditBrands = async () => {
    setLoading(true);
    toggleModal()
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      const formData = new FormData();
      formData.append('_method', 'PATCH');

      selectedOptions.forEach(option => {
        formData.append('brand_ids[]', option.value); // 'value' contains the ID
      });
      console.log("formData",formData)
      const response = await fetch(`${baseUrl}/categories/${selectedCategory.id}/brands`, {
        method: 'Post',
        headers: {
          'Accept': 'application/json',
          "Authorization": 'Bearer ' + token,
        },
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        console.log("data",data)
        fetchCategories()
      } else {
        toast.error('Failed to fetch brand');
      }
    } catch (err) {
      setError('Failed to fetch brand');
    } finally {
      setLoading(false);
    }
  };
  const fetchCategories = async () => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      const response = await fetch(`https://dashboard.onyxen-regalia.com/backend/api/categories`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log("data",data)
        setCategories(data.categories); // Adjust based on your API response structure
      } else {
        toast.error('Failed to fetch categories');
      }
    } catch (err) {
      setError('Failed to fetch categories');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBrands()

    fetchCategories(currentPage);
  }, [currentPage]);

  const handleEditClick = (category) => {
    navigate(`/Categories/edit/${category.id}`, { state: { category } });
  };

  const handleDeleteClick = (category) => {
    setCategoryToDelete(category);
    setShowModal(true);
  };

  const confirmDelete = async () => {
    if (!categoryToDelete) return;

    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      const response = await fetch(`${baseUrl}/categories/${categoryToDelete.id}`, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
          'x-api-key': 'web-app',
        },
      });

      if (response.ok) {
        toast.success('Category deleted successfully!');
        // Remove the deleted category from the state
        setCategories(categories.filter(category => category.id !== categoryToDelete.id));
        setShowModal(false); // Close the modal after successful deletion
      } else {
        toast.error('Failed to delete category');
      }
    } catch (err) {
      toast.error('An error occurred while deleting the category.');
    } finally {
      setLoading(false);
    }
  };

  const cancelDelete = () => {
    setShowModal(false);
    setCategoryToDelete(null);
  };

  const handleAddNewCategory = () => {
    navigate('/Categories/new-category');
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  
  const handleCategoryEdit = (category) => {
    setSelectedCategory(category);
    navigate(`/Categories/edit/${category.id}`, { state: { category } });
  };
  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    toggleModal(); // Open modal

    const formattedOptions = category.brands.map(option => ({
      value: option.id,
      label: `${option.name.en} - ${option.name.ar}`,
    }));

    setSelectedOptions(formattedOptions); // Reset selected options

  };
  const formattedOptions = BrandList.map(option => ({
    value: option.id,
    label: `${option.name.en} - ${option.name.ar}`,
  }));
  const customStyles = {
    flexDirection: "column",

    control: (base) => ({
      ...base,
      backgroundColor: "#fff",
      flexDirection:'column',
      fontSize: 20,
      color: "#000",
      border: "1px solid #ccc",
      boxShadow: "none",
      "&:hover": {
        border: "1px solid #888",
      },
      width: "100%",
      margin: "0 auto", // Center align
    
    }),
    option: (base, { isFocused, isSelected }) => ({
      ...base,
      backgroundColor: isSelected
        ? "rgba(154, 57, 57, 0.8)"
        : isFocused
          ? "rgba(154, 57, 57, 0.2)"
          : "#fff",
      color: isSelected ? "#fff" : "#000",
      fontSize: 18,
      padding: 10,
      flexDirection: "column",

    }),
    multiValue: (base) => ({
      ...base,
      backgroundColor: "rgba(154, 57, 57, 0.2)",
      color: "#000",
      fontSize: 16,
      borderRadius: 5,
      flexDirection: "column",

    }),
    multiValueLabel: (base) => ({
      ...base,
      color: "#000",
      flexDirection: "column",

    }),
    multiValueRemove: (base) => ({
      ...base,
      color: "#000",
      ":hover": {
        backgroundColor: "rgba(154, 57, 57, 0.8)",
        color: "#fff",
        flexDirection: "column",

      },
    }),
  };
  const handleChange = selected => {
    setSelectedOptions(selected);
    setNewSelectedOptions(selected);
  };
  // const handleNextPage = () => {
  //   if (currentPage < lastPage) {
  //     setCurrentPage(currentPage + 1);
  //   }
  // };

  return (
    <div className="dashboard">
      <button className="add-category-button" onClick={handleAddNewCategory} style={{ backgroundColor: 'rgb(154, 57, 57)' }}>
        <FontAwesomeIcon icon={faPlus} /> Add New Category
      </button>
      <div className="category-list">
        {loading && (
          <div className="loader-overlay">
            <div className="loader"></div>
          </div>
        )}
        {!loading && categories.map(category => (
       category.parent_id == null &&
          <div key={category.id} className="category-item">
            <div className="category-row">
              <span className="category-id">ID: {category.id}</span>
              <img src={category.photo} alt={category.name} className="category-image" />
              <div style={{width:"50%"}}>
              <h3 className="category-name" style={{ color: "rgb(154, 57, 57)" }}>{category.name.en}</h3>
              <h3 className="category-name" style={{ color: "rgb(154, 57, 57)" }}>{category.name.ar}</h3>
              </div>
            
              <div className="buttons">
              <button className="edit" onClick={()=> handleCategoryClick(category)}>
                <p>Brands</p>
                </button>
                <button className="edit" onClick={()=> handleCategoryEdit(category)}>
                <p>Edit</p>
                </button>
                <button className="delete" onClick={() => handleDeleteClick(category)}>
                  <FontAwesomeIcon icon={faTrashAlt} color='#000' />
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>

 {/* {lastPage > 1 && 
 
      <div className="pagination-controls">
        <button
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
          style={{ marginRight: '10px', backgroundColor: 'rgb(154, 57, 57)', color: '#fff' }}
        >
          Previous
        </button>
        <span>Page {currentPage} of {lastPage}</span>
        <button
          onClick={handleNextPage}
          disabled={currentPage === lastPage}
          style={{ marginLeft: '10px', backgroundColor: 'rgb(154, 57, 57)', color: '#fff' }}
        >
          Next
        </button>
      </div>
 } */}

      {showModal && (
        <div className="modal show">
          <div className="modal-content">
            <h3 style={{ color: '#000' }}>Are you sure you want to delete this category?</h3>
            <button className="cancel-button" onClick={cancelDelete} style={{ backgroundColor: "#000" }}>Cancel</button>
            <button className="delete-button" onClick={confirmDelete} style={{ backgroundColor: 'rgb(154, 57, 57)' }}>Delete</button>
          </div>
        </div>
      )}



<Modal
        isOpen={isModalOpen}
        onRequestClose={toggleModal}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          },
          content: {
            color: "#000",
            width: "40%",
            margin: "auto",
            padding: "20px",
            borderRadius: "8px",
            backgroundColor: "#fff",
          },
        }}
      >
        <h3>Select Brands</h3>
        <div style={{ width: "100%" }}>
          {/* <Select
            options={formattedOptions}
            isMulti
            onChange={handleChange}
            value={selectedOptions}
            styles={customStyles}
          /> */}

<Select
            options={formattedOptions}  // Use brands for the selected category
            isMulti
            onChange={handleChange}
            value={selectedOptions}
            styles={customStyles}
          />
        </div>
        <button onClick={EditBrands} style={{ marginTop: "10px" }}>Close</button>
      </Modal>
    </div>
  );
};

export default Categories;
